import { Text } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import { StakingInterface } from './components/StakingInterface'

const StakeSOL = () => {
  return (
    <>
      <Text type="h4" className="py-8">
        <Trans>Stake SOL and Receive $DATA Airdrop</Trans>
      </Text>
      <StakingInterface />
    </>
  )
}

export default StakeSOL
